/* eslint-disable import/no-cycle */
import React, { useEffect, useState } from 'react';
import { FModal } from '@components';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@pages/Shell';
import { obterPendenciasUsuarioRequest } from '../../store/modules/user/actions';
import { ListagemPendencia } from './components/listaPendencias';
import { Consentimento } from './components/consentimento';
import { LOGIN } from '../../common/utils/paths';
import { AtualizacaoCadastral } from './components/atualizacaoCadastral';
import { baseADM } from '../../common/services/env-variables';

export const PendenciaModal = () => {
  const dispatch = useDispatch();
  const ambienteURL = baseADM;
  const onlyADM = window.location.origin.indexOf(ambienteURL) > -1;
  const user = useSelector((state) => state.user);
  const auth = useAuth();
  const [possuiPendencias, setPossuiPendencias] = useState(false);
  const [pendenciaAtiva, setPendenciaAtiva] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(true);

  const logout = () => {
    auth.signout();
  };

  useEffect(() => {
    setPossuiPendencias(
      !!Object.values(user.pendencias).find((pendencia) => pendencia === 1)
    );
  }, [user, pendenciaAtiva]);

  useEffect(() => {
    if (user.matricula) {
      dispatch(
        obterPendenciasUsuarioRequest({
          matricula: user.matricula,
          token: user.token,
        })
      );
    }
  }, [dispatch, user.matricula, user.token, pendenciaAtiva]);

  return (
    <FModal
      isOpen={possuiPendencias && modalIsOpen}
      close={onlyADM}
      onClose={() => {
        if (onlyADM) {
          setModalIsOpen(false);
        }
      }}
      widthAuto
    >
      {pendenciaAtiva === '' && (
        <ListagemPendencia
          nome={user.nome}
          pendencias={user.pendencias}
          setPendenciaAtiva={setPendenciaAtiva}
        />
      )}
      {pendenciaAtiva === 'assinaturaDoc' && (
        <Consentimento user={user} setPendenciaAtiva={setPendenciaAtiva} />
      )}
      {pendenciaAtiva === 'atualizacaoCadastral' && (
        <AtualizacaoCadastral
          user={user}
          setPendenciaAtiva={setPendenciaAtiva}
        />
      )}
      <p className="ts-12 mt-4 text-center">
        Seu acesso ao portal estará disponível após a resolução das pendências.
        Se preferir não resolvê-las agora, você pode encerrar sua sessão{' '}
        <NavLink to={LOGIN} onClick={logout}>
          clicando aqui
        </NavLink>
        .
      </p>
    </FModal>
  );
};
